/**
 * Extracted from sections/ns-image-cards.liquid (inline <script> at line 527).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-image-cards.liquid:527) ---
  (function() {
    var DEBUG = true;
    function log() {
      if (DEBUG && typeof console !== 'undefined' && console.log) {
        console.log.apply(console, ['[ns-image-cards]'].concat(Array.prototype.slice.call(arguments)));
      }
    }

    function initImageCardHover() {
      log('initImageCardHover called');
      const container = document.querySelector('.ns-image-cards__grid');
      if (!container) {
        log('FAIL: .ns-image-cards__grid not found');
        return;
      }
      log('container found', container);

      const hoverWrapper = container.closest('.ns-image-cards--hover-enabled') || container.closest('[data-ns-image-cards-hover="true"]');
      if (!hoverWrapper) {
        log('FAIL: no hover-enabled ancestor (enable "Enable card hover expand" in section settings)');
        return;
      }
      log('hover-enabled wrapper found', hoverWrapper);

      if (container.dataset.nsImageCardHoverInit === 'true') {
        log('already initialized, skip');
        return;
      }

      const allCards = Array.from(container.querySelectorAll('.image-card-block--hover-enabled'));
      log('total cards:', allCards.length);

      container.dataset.nsImageCardHoverInit = 'true';

      let lastActiveCard = allCards.find(function(c) { return c.classList.contains('image-card-block--default-active'); }) || null;
      allCards.forEach(function(c) { c.classList.remove('image-card-block--active'); });
      if (lastActiveCard) lastActiveCard.classList.add('image-card-block--active');

      const isMobile = window.innerWidth <= 768;
      log('isMobile:', isMobile, 'viewport width:', window.innerWidth);

      if (isMobile) {
        const updateActiveCard = function() {
          const scrollMid = container.scrollLeft + container.clientWidth / 2;
          let currentCard = null;
          for (var i = 0; i < allCards.length; i++) {
            const card = allCards[i];
            const left = card.offsetLeft;
            const width = card.offsetWidth;
            if (scrollMid >= left && scrollMid < left + width) {
              currentCard = card;
              break;
            }
          }
          if (!currentCard && allCards.length > 0) {
            currentCard = scrollMid < allCards[0].offsetLeft ? allCards[0] : allCards[allCards.length - 1];
          }
          if (currentCard) {
            allCards.forEach(function(c) { c.classList.remove('image-card-block--active'); });
            currentCard.classList.add('image-card-block--active');
            lastActiveCard = currentCard;
          }
        };
        var scrollEndTimer;
        container.addEventListener('scroll', function() {
          updateActiveCard();
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(updateActiveCard, 150);
        }, { passive: true });
        updateActiveCard();
        log('mobile: scroll listener on grid, current slide = image-card-block--active');
      } else {
        allCards.forEach(function(currentCard) {
          const hoverOnlyActivate = currentCard.getAttribute('data-hover-only-activate') === 'true';
          currentCard.addEventListener('mouseenter', function() {
            allCards.forEach(function(c) { c.classList.remove('image-card-block--active'); });
            currentCard.classList.add('image-card-block--active');
            lastActiveCard = currentCard;
          });
          currentCard.addEventListener('mouseleave', function() {
            if (hoverOnlyActivate) {
              currentCard.classList.remove('image-card-block--active');
              allCards.forEach(function(c) { c.classList.remove('image-card-block--active'); });
            } else if (lastActiveCard) {
              allCards.forEach(function(c) { c.classList.remove('image-card-block--active'); });
              lastActiveCard.classList.add('image-card-block--active');
            }
          });
        });
        log('desktop: listeners attached (1 active for whole grid)');
      }
    }

    log('script run, readyState:', document.readyState);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { log('DOMContentLoaded'); initImageCardHover(); });
    } else {
      initImageCardHover();
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        var container = document.querySelector('.ns-image-cards__grid');
        if (container) container.dataset.nsImageCardHoverInit = 'false';
        setTimeout(initImageCardHover, 100);
      });
    }
  })();
